export const ONBOARDING_TUTORIAL_PARAMS = {
  start_url: "start-url",
  id: "id",
  asset_id: "asset_id",
  total_steps: "total_steps",
};
